const STATUS_LABELS: Readonly<Record<string, string>> = {
  ALL: "全部",
  AUTHORIZED: "已授权",
  NOT_CONNECTED: "未连接",
  REVOKED: "已收回权限",
  IDLE: "空闲（当前无同步任务）",
  SYNCING: "正在同步",
  NEW: "新建",
  ACTIVE: "活跃",
  INACTIVE: "停用",
  ARCHIVED: "已归档",
  RETIRED: "已停用",
  PROSPECT: "潜在客户",
  CLEAR: "当前未发现已确认风险",
  CONFIRMED_RISK: "已确认风险",
  RESOLVED: "已解决",
  HEALTHY: "正常",
  READY_FOR_TEST: "待测试",
  TEST_DATA_ACTIVE: "合成测试数据已启用",
  PAUSED: "已暂停",
  MISSING: "缺失",
  CONFIGURED: "已配置",
  UNCONFIGURED: "未配置",
  COMPLETE: "完整",
  PARTIAL: "部分覆盖",
  HISTORY_COVERAGE_UNKNOWN: "历史覆盖范围待确认",
  FULL_HISTORY_CONFIRMED: "已确认完整历史覆盖",
  LOW: "低",
  UNASSESSED: "未评估",
  NORMAL: "普通",
  MEDIUM: "中",
  HIGH: "高",
  URGENT: "紧急",
  DRAFT: "草稿",
  PENDING: "待处理",
  RUNNING: "运行中",
  COMPLETED: "已完成",
  SUCCEEDED: "成功",
  FAILED: "失败",
  CANCELLED: "已取消",
  VALID: "有效",
  INVALID: "无效",
  UNKNOWN: "未知",
  CREATED: "已创建",
  CASE_CREATED: "已创建案件",
  LINKED: "已关联",
  NOT_REVIEWED: "未审核",
  REVIEW_REQUIRED: "待人工复核",
  PENDING_APPROVAL: "待审批",
  WAITING_APPROVAL: "等待审批",
  APPROVED: "已批准",
  REJECTED: "已拒绝",
  CHANGES_REQUESTED: "已要求修改",
  QUEUED: "已排队",
  READY: "就绪",
  READY_TO_SEND: "待发送",
  READY_TO_QUOTE: "待报价",
  QUOTING: "报价准备中",
  WAITING_SOURCING: "等待查货结果",
  NOT_REQUIRED: "不需要",
  SUBMITTED: "已提交",
  NO_SUPPLY: "无货",
  FAKE_SENT: "已合成发送",
  SENT_SYNTHETIC: "已合成发送",
  RESPONDED: "已回复",
  SENT: "已发送",
  RECEIVED: "已收到",
  NORMALIZED: "已标准化",
  MATCH_REVIEW: "匹配复核",
  RISK_REVIEW: "风险复核",
  CASE_REVIEW: "案件复核",
  COMMERCIAL: "商业处理",
  ROUTED: "已路由",
  NOT_RUN: "未运行",
  NEW_INQUIRY: "新询价",
  EXISTING_CASE_REPLY: "已有案件回复",
  STAFF_REPLY: "内部员工回复",
  PURCHASE_ORDER: "采购订单",
  GENERAL_QUESTION: "一般咨询",
  SUPPLIER_OR_SERVICE_OUTREACH: "供应商或服务推广",
  AUTOMATED_NOTIFICATION: "自动通知",
  SPAM_OR_PHISHING: "垃圾或钓鱼邮件",
  DISTRIBUTE_SALES_AND_SOURCING: "销售与查货并行分发",
  DUPLICATE_REVIEW: "重复询单复核",
  HUMAN_REVIEW: "人工复核",
  RETURNED: "已返回",
  REVIEWED: "已复核",
  RULE_BASED: "规则判断",
  SOURCE_DOMAIN_UNMATCHED: "来源域名未匹配站点",
  NO_ACTIVE_TRIAGE_OWNER: "没有有效分诊负责人",
  PRIMARY_UNAVAILABLE_AND_BACKUP_UNAVAILABLE: "主负责人和备用负责人均不可用",
  SUPERSEDED: "已被新版本取代",
  EXPIRED: "已过期",
  WAITING: "等待中",
  OVERDUE: "已逾期",
  ON_TRACK: "正常",
  TODO: "待处理",
  OPEN: "待处理",
  ACKNOWLEDGED: "已确认",
  ASSIGNED: "已分配",
  ACCEPTED: "已接受",
  DECLINED: "已退回",
  ACCEPTANCE_OVERDUE: "接受逾期",
  WAITING_ASSIGNMENT: "待分配",
  IN_PROGRESS: "处理中",
  WAITING_CUSTOMER: "等待客户",
  WAITING_INTERNAL: "等待内部处理",
  PROCESSING_OVERDUE: "处理逾期",
  REASSIGNMENT_REQUIRED: "需要重新分配",
  REASSIGNED: "已重新分配",
  CLOSED: "已关闭",
  ACTIVE_QUEUE: "活跃队列",
  BUSY: "忙碌",
  ON_LEAVE: "休假",
  UNAVAILABLE: "不可用",
  DELEGATED: "已代理",
  ENABLED: "已启用",
  DISABLED: "已停用",
  REAL: "真实",
  DEMO: "演示",
  ACCEPT: "接受",
  ACCEPT_WITH_CHANGES: "修改后接受",
  REJECT: "拒绝",
  RETRY: "重试",
  APPROVE: "批准",
  REQUEST_CHANGES: "要求修改",
  STRONG: "强",
  WEAK: "弱",
  MANUAL_REVIEW: "人工复核",
  TECHNICAL_REVIEW: "技术复核",
  SYNTHESIS_VALID: "合成结果有效",
  UNREVIEWED: "未审核",
  IN_REVIEW: "审核中",
  QUALIFIED: "资质合格",
  CONDITIONALLY_QUALIFIED: "有条件合格",
  BLOCKED: "已阻止",
  ESCALATED: "已升级",
  SKIPPED: "已跳过",
  NOT_STARTED: "未开始",
  WARNING: "预警",
  BREACHED: "已超时",
  ACCEPTANCE: "接受",
  PROCESSING: "处理",
  REVIEW: "复核",
  APPROVAL: "审批",
  ACCEPTANCE_WARNING: "接受时限预警",
  ACCEPTANCE_BREACH: "接受时限超时",
  PROCESSING_WARNING: "处理时限预警",
  PROCESSING_BREACH: "处理时限超时",
  HANDOFF_TIMEOUT: "交接超时",
  MARGIN: "毛利",
  PAYMENT_TERMS: "付款条款",
  CREDIT_TERMS: "信用条款",
  HIGH_VALUE: "高金额",
  LOW_MARGIN: "低毛利",
  RISK: "风险",
  SPECIAL_CONTRACT: "特殊合同",
  EXPORT_COMPLIANCE: "出口合规",
  TECHNICAL_DEVIATION: "技术偏差",
  CASE_PARALLEL_DISTRIBUTED: "销售与查货已并行分发",
  REAL_GMAIL_INQUIRY_DISTRIBUTED: "真实 Gmail 询单已内部分发",
  "EMAIL_INQUIRY.INTERNAL_DISTRIBUTION.COMPLETED":
    "真实 Gmail 询单内部分发完成",
  SOURCING_RESULT_SUBMITTED: "查货结果已提交",
  SOURCING_NO_SUPPLY: "查货结果为无货",
  INQUIRY_PARALLEL_DISTRIBUTION: "询单并行分发",
  SOURCING_DRAFT_SAVE: "查货草稿保存",
  SOURCING_RESULT_SUBMIT: "查货结果提交",
  PRIMARY_SITE: "主站点",
  UNIVERSITY: "高校 / 大学",
  ENTERPRISE: "企业",
  DISTRIBUTOR: "分销商",
  NO_HISTORY: "无查货历史",
  RECENT_VALID_SUCCESS: "近期有效成功记录",
  RECENT_NO_SUPPLY: "近期无货记录",
  OLDER_SUCCESS: "较早成功记录",
  MULTIPLE_NO_SUPPLY: "多次无货记录",
  PARALLEL_DISTRIBUTION_CANDIDATE: "销售与查货并行分发候选",
  ONE_CLICK_CONFIRM: "一键确认候选",
  MANUAL_TRIAGE: "人工分诊",
  REQUEST_INFORMATION_CANDIDATE: "补充信息候选",
  LINK_EXISTING_CASE_CANDIDATE: "关联已有案件候选",
  SALES_ONLY_CANDIDATE: "仅销售处理候选",
  HOLD_OR_RISK_REVIEW: "暂停或风险复核",
};

const ROLE_LABELS: Readonly<Record<string, string>> = {
  UAT_ADMIN: "UAT 管理员",
  WORKSPACE_ADMIN: "工作空间管理员",
  PLATFORM_ADMIN: "平台管理员",
  TRIAGE_AGENT: "询单分诊专员",
  SALES: "销售",
  SALES_OWNER: "销售负责人",
  SOURCING: "寻源",
  PROCUREMENT: "查货人员",
  APPROVER: "审批人",
  COMMERCIAL_APPROVER: "商业审批人",
  AUDITOR: "审计员",
  READ_ONLY_AUDITOR: "只读审计员",
  OWNER: "负责人",
  MEMBER: "成员",
  LEAD: "组长",
  TEAM_MANAGER: "团队经理",
  DISPATCHER: "分发员",
  REVIEWER: "复核员",
  PRIMARY_OWNER: "主负责人",
  COLLABORATOR: "协作人",
  WATCHER: "关注人",
};

const OBJECT_TYPE_LABELS: Readonly<Record<string, string>> = {
  CUSTOMER: "客户",
  CONTACT: "联系人",
  CASE: "案件",
  INQUIRY_CASE: "案件",
  INQUIRY: "询单",
  INBOUND_INQUIRY: "入站询单",
  WEBSITE_INQUIRY: "网站询单",
  TASK: "任务",
  CASE_TASK: "案件任务",
  SUPPLIER_RFQ: "供应商询价",
  CUSTOMER_QUOTE: "客户报价",
};

const BUSINESS_TYPE_LABELS: Readonly<Record<string, string>> = {
  CHEMICAL_REAGENT: "化学试剂",
  EMBODIED_INTELLIGENCE: "具身智能",
};

const AI_MODE_LABELS: Readonly<Record<string, string>> = {
  DIRECT_STRICT: "直接严格模式",
  THINK_THEN_STRICT: "思考后严格模式",
  TEXT_ONLY: "仅文本模式",
  DIRECT: "直接调用",
  ANALYSIS: "分析",
  PROJECTION: "结构化投影",
  enabled: "已启用",
  disabled: "已停用",
  high: "高",
  max: "最高",
};

const USE_CASE_LABELS: Readonly<Record<string, string>> = {
  inquiry_quality_judgment_v1: "询单质量判断",
  customer_judgment_v1: "客户判断",
  basic_chemical_extraction_v1: "化学信息提取",
  routing_recommendation_v1: "路由建议",
  commercial_potential_judgment_v1: "商业潜力判断",
  purchase_intent_judgment_v1: "采购意向判断",
  business_fit_judgment_v1: "业务匹配度判断",
};

function normalized(value: string): string {
  return value.trim().replaceAll(" ", "_").toUpperCase();
}

function unknown(kind: string, value: string): string {
  return `未识别${kind}（${value}）`;
}

export function statusLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return STATUS_LABELS[normalized(value)] ?? "状态待确认";
}

export function confidenceLabel(value: string | null | undefined): string {
  if (!value) return "—";
  if (!Number.isNaN(Number(value))) return value;
  const label = STATUS_LABELS[normalized(value)];
  return label ?? unknown("置信度", value);
}

export function roleLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return ROLE_LABELS[normalized(value)] ?? unknown("角色", value);
}

export function objectTypeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return OBJECT_TYPE_LABELS[normalized(value)] ?? unknown("对象类型", value);
}

export function businessTypeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return BUSINESS_TYPE_LABELS[normalized(value)] ?? unknown("业务类型", value);
}

export function aiModeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return (
    AI_MODE_LABELS[value] ??
    AI_MODE_LABELS[normalized(value)] ??
    unknown("模式", value)
  );
}

export function useCaseLabel(code: string): string {
  return USE_CASE_LABELS[code] ?? unknown("用例", code);
}

export function listLabels(
  values: readonly string[],
  formatter: (value: string) => string = statusLabel,
): string {
  return values.map(formatter).join("、");
}
